import { render } from "./ServiceTileShimmer.vue?vue&type=template&id=453d4561"
import script from "./ServiceTileShimmer.vue?vue&type=script&lang=js"
export * from "./ServiceTileShimmer.vue?vue&type=script&lang=js"
script.render = render

export default script